import type { PatentData } from '@/services/patent-service.interface';
import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';
import _ from 'lodash';
import { computed, type Ref } from 'vue';

const HAS_AI_TRANSLATION_LANG = ['CN', 'EN', 'JP'];

function getVisible() {
    const isFree = getIsFreeView();
    const serviceArea = _.get(window, 'zPREFACE.accountInfo.site_region', 'CN');
    return !isFree && serviceArea === 'CN';
}

const getPatentLanguage = (patent: Partial<PatentData>): string => {
    const type = patent.TYPE || []; // TYPE包含PN号国家
    // 获取专利语言逻辑
    // 优先TYPE，然后ABST_LANG
    const language = _.find(type, (item) => HAS_AI_TRANSLATION_LANG.includes(item));
    return language || patent.ABST_LANG || '';
};

export function useAiOptions(patent: Ref<Partial<PatentData>>) {
    const currentPatentLang = computed(() => getPatentLanguage(patent.value));

    const visibleCN = computed(() => getVisible() && currentPatentLang.value === 'JP');
    const visibleJP = computed(() => getVisible() && (currentPatentLang.value === 'CN' || currentPatentLang.value === 'EN'));
    const visibleEN = computed(() => getVisible() && currentPatentLang.value === 'JP');

    const aiOptions = computed(() => {
        const langs = [
            {
                lang: 'AIJP',
                label: '日本語 - AIpatent',
                show: visibleJP.value,
            },
            {
                lang: 'AIEN',
                label: 'English - AIpatent',
                show: visibleEN.value,
            },
            {
                lang: 'AICN',
                label: '简体中文 - AIpatent',
                show: visibleCN.value,
            },
        ];

        return langs.filter((item) => item.show);
    });

    return {
        aiOptions,
    };
};
